module.exports = __webpack_public_path__ + "img/lightyear.61fb696a.svg";